import log from 'salvo-lite/log'

class SelectURL {
    constructor (theme, elem) {
        this._select = elem
    }

    onInit () {
        this._select.addEventListener('change', function () {
            log.debug('SelectURL', 'Change event', this)
            window.location.href = this.value
        })
    }
}

export default SelectURL



// WEBPACK FOOTER //
// ./src/scripts/components/SelectURL.js